<template>
    <div class="basic_wrap ranking">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('Rankings')}}</div>
        </div>
        <div class="wrap">
            <div class="top1">
                <div>{{top1.username}}</div>
                <div class="desc">{{ Number(top1 && top1.total_recharge || 0).toFixed(2) }}</div>
            </div>
            <div class="top2">
                <div>{{top2.username}}</div>
                <div class="desc">{{ Number(top2 && top2.total_recharge || 0).toFixed(2) }}</div>
            </div>
            <div class="top3">
                <div>{{top3.username}}</div>
                <div class="desc">{{ Number(top3 && top3.total_recharge || 0).toFixed(2) }}</div>
            </div>
            <div class="other">
                <div class="other-bg">
                    <div class="item" v-for="(item, index) in others">
                        <div class="circle">{{ index + 4 }}</div>
                        <div class="info">
                            <div class="name">{{ item.username }}</div>
                            <div class="amount">{{ Number(item && item.total_recharge || 0).toFixed(2) }}</div>
                        </div>
                    </div>

                </div>
                <div style="height: 30px;"></div>
            </div>
        </div>

        <div @click="showRule = true" class="rule">
            <img src="@/assets/images/rule.svg">
        </div>
        <!-- 活动规则 -->
        <van-popup v-model="showRule" position="center" round :style="{ width: '80%', padding: '16px' }">
            <div class="action-sheet-center">
                <div class="text-center font-16 font-bold mt-10 font-white">{{rule.title}}</div>
                <div class="mt-20 font-14 font-white" v-html="rule.content"></div>
                <div class="btn-white" @click="showRule = false">{{$t('OK')}}</div>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import Fetch from "../../utils/fetch";

    export default {
        name: "ranking",
        data() {
            return {
                list:[],
                activeNames: [],
                top1: '',
                top2: '',
                top3: '',
                others: [],
                rule: {},
                showRule: false,
            }
        },
        created() {
            this.$parent.footer('index', false);
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                // 获取排行榜数据
                Fetch('/index/rankings', { }).then(res => {
                    this.top1 = res.data.top1;
                    this.top2 = res.data.top2;
                    this.top3 = res.data.top3;
                    this.others = res.data.others;
                    this.rule = res.data.rule;
                })
            },
        },
    }
</script>

<style lang="less" scoped>
    .basic_wrap {
        width: 100%;
        min-height: 100vh;
        background: url("~@/assets/images/rankings.png") no-repeat top left;
        background-size: 100% auto; /* 宽度100%，高度按比例自适应 */
    }
    .back_left {
        background: url(../../views/images/item/back.png) no-repeat center center;
    }
    .big_tit{
        color: #fff;
    }
    .red_top_bg {
        background: unset;
    }
    .wrap {
    }
    .top1 {
        top: 176px;
        left: 142px;
        width: 90px;
    }
    .top2 {
        top: 216px;
        left: 40px;
        width: 90px;
    }
    .top3 {
        top: 219px;
        right: 39px;
        width: 95px;
    }
    .top1, .top2 , .top3 {
        position: absolute;
        text-align: center;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #fff;
        .desc {
            background: #76a1f0;
            padding: 5px 10px;
            color: #fff;
            font-size: 13px;
            display: inline-block;
            border-radius: 5px;
        }
    }
    .other {
        background: #2066e6;
        width: 100%;
        margin-top: 330px;
        min-height: 300px;
    }
    .other-bg {
        background: #f0efff;
        margin: 20px 10px 0px 10px;
        padding: 20px;
        border-radius: 10px;
    }
    .item {
        display: flex;          /* 左右布局 */
        align-items: center;    /* 垂直居中 */
        gap: 20px;              /* 左右间距 */
        background: #fff;
        padding: 15px;
        border-radius: 10px;
        margin-bottom: 15px;
    }
    .item:last-child {
        margin-bottom: 0;   /* 最后一个不要间距 */
    }
    .info {
        display: flex;
        flex-direction: column; /* 上下布局 */
        justify-content: center;
    }

    .name {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 10px;
    }

    .amount {
        font-size: 14px;
        color: #666;
    }
    /* 小平板：iPad Mini, 768px 宽度 */
    @media screen and (max-width: 768px) {
        .top1 {
            top: 365px;
            left: 308px;
            width: 135px;
        }
        .top2 {
            top: 436px;
            left: 102px;
            width: 135px;
        }
        .top3 {
            top: 439px;
            right: 105px;
            width: 135px;
        }
    }
    /* 大屏手机：iPhone 14 Plus, 430px 宽度 */
    @media screen and (max-width: 430px) {
        .top1 {
            top: 204px;
            left: 155px;
            width: 120px;
        }
        .top2 {
            top: 248px;
            left: 48px;
            width: 100px;
        }
        .top3 {
            top: 251px;
            right: 49px;
            width: 100px;
        }
    }
    /* 大屏手机：iPhone 6/7/8 Plus, 414px 宽度 */
    @media screen and (max-width: 414px) {
        .top1 {
            top: 197px;
            left: 147px;
            width: 120px
        }
        .top2 {
            top: 236px;
            left: 44px;
            width: 100px;
        }
        .top3 {
            top: 238px;
            right: 45px;
            width: 100px;
        }
    }
    /* 中屏手机：iPhone 12, 390px 宽度 */
    @media screen and (max-width: 390px) {
        .top1 {
            top: 185px;
            left: 135px;
            width: 120px;
        }
        .top2 {
            top: 222px;
            left: 37px;
            width: 100px;
        }
        .top3 {
            top: 223px;
            right: 38px;
            width: 100px;
        }
    }
    /* 中屏手机：iPhone 6/7/8, 375px 宽度 */
    @media screen and (max-width: 375px) {
        .top1 {
            top: 176px;
            left: 142px;
            width: 90px;
        }
        .top2 {
            top: 216px;
            left: 40px;
            width: 90px;
        }
        .top3 {
            top: 219px;
            right: 39px;
            width: 95px;
        }
    }
    /* 小屏手机：iPhone SE, 360px 宽度 */
    @media screen and (max-width: 360px) {
        .top1 {
            top: 170px;
            left: 135px;
            width: 90px;
        }
        .top2 {
            top: 205px;
            left: 36px;
            width: 90px;
        }
        .top3 {
            top: 207px;
            right: 32px;
            width: 95px;
        }
    }
</style>